// Production URL
// export const BASE_URL = "https://api.get-part.co.il:9072/api/v1";
// export const IMAGE_BASE_URL = "https://api.get-part.co.il:9072";

export const BASE_URL = "https://api.get-part.co.il:9072/api/v1";

export const IMAGE_BASE_URL = "https://api.get-part.co.il:9072";
